import React from 'react';
import PropTypes from 'prop-types';
import Input, { InputTypes } from '../../input';

const RenInputNumber = ({
  data, accessor, onAction, columnData,
}) => (
  <div className="tbl-ren-input-number">
    <Input
      type={InputTypes.NUMBER}
      value={data[accessor]}
      onChange={(e) => { onAction(e.target.value); }}
      placeholder={columnData.placeholder || '0'}
    />
  </div>
);

RenInputNumber.defaultProps = {
  data: {},
  columnData: {
    placeholder: '0',
  },
  onAction: () => {},
};

RenInputNumber.propTypes = {
  id: PropTypes.string.isRequired,
  accessor: PropTypes.string.isRequired,
  data: PropTypes.shape(),
  onAction: PropTypes.func,
  columnData: PropTypes.shape({
    placeholder: PropTypes.string,
  }),
};

export default RenInputNumber;
